import { useMutation, useQueryClient } from "react-query";
import { EExercisesQueryKeys } from "api/endpoints/exercises";
import { editExercise } from "api/services/exercises";
import { logError } from "utils/notifications";
import { TApiError } from "types/api/error";
import { TEditExercise, TExercise } from "types/api/exercise";
import { TUrlParam } from "types/utils";

export const useEditExercise = <
  TPayload = Record<string, unknown>,
  TText extends string = string
>(
  courseId: TUrlParam,
  lessonId: TUrlParam,
  chapterId: TUrlParam
) => {
  const queryClient = useQueryClient();
  return useMutation<
    TExercise<TPayload, TText>,
    TApiError,
    TEditExercise<TPayload, TText>
  >(
    (chapterExercise: TEditExercise<TPayload, TText>) =>
      editExercise<TPayload, TText>(
        courseId,
        lessonId,
        chapterId,
        chapterExercise
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(EExercisesQueryKeys.getExercises);
      },
      onError: (error) => logError({ error }),
      retry: false,
    }
  );
};
